import React from 'react';
import { withRouter,Link } from 'react-router-dom';
import {Button} from 'antd';
import {connect} from 'react-redux';
import BaseContent from 'components/BaseContent';
import Table from 'components/Table';
import {getBundles,deleteBundle} from 'actions/bundle';
import {getAppkeys} from 'actions/appkey';
import style from './index.less';
import {renderStateText} from 'utils/bundleConst';
import BaseModal from 'components/BaseModal';

class BundleList extends React.Component {
    state = {
        list: [],
        loading:true,
        hasAppKey:false
    };
    columns = [{
        title: 'BundleID',
        dataIndex: 'bundle_id',
        key: 'bundle_id'
    },{
        title: 'Platform',
        dataIndex: 'platform',
        key: 'platform'
    },{
        title: 'Expire Date',
        dataIndex: 'expired_time',
        key: 'expired_time'
    },{
        title: 'State',
        dataIndex: 'state',
        key: 'state',
        render: (text, item) => {
            return renderStateText(item);
        }
    },{
        title: 'Operation',
        dataIndex: 'operation',
        width:200,
        key: 'operation',
        render: (text, item) => {
            const ops = [];
            const has_permission = this.has_permission();
            if (!has_permission) {
                return ops;
            }
            ops.push(<Link key='j' style={{marginRight:30}} to={'/pages/app/bundle/' + item.sdk_req_id}> Check </Link>);
            if (item.auth_type === 2 && item.status !== 0) {
                const bundle_data = {
                    bundle_id: item.bundle_id,
                    sdk_req_id: item.sdk_req_id
                };
                if(item.status === 1){
                    ops.push(<a onClick={this.onDelete.bind(this,bundle_data)}> Delete </a>);
                }else{
                    ops.push(<a onClick={this.showDeleteModal.bind(this,bundle_data)}> Unbind </a>);
                }

            }
            return ops;
        }
    },];

    onDelete = (data)=>{
        deleteBundle(data.sdk_req_id).then(()=>{
            this.table.refresh();
        });
    }

    showDeleteModal(data){
        BaseModal.error({
            title:<span>Are you sure to unbind <span style={{color:'#8A90FF'}}>{data.bundle_id}</span></span>,
            content:<span>Note: After unbinding, the mobile client corresponding to the Bundle ID will not be able to obtain FaceID authorization.</span>,
            onOk:()=>{
                deleteBundle(data.sdk_req_id).then(res=>{
                    this.table.refresh();
                });
            },
            onCancel:()=>{

            }
        });
    }

    has_permission() {
        const permissions = this.props.account.permissions;
        return permissions && permissions.includes('outer_faceid_bundleid');
    }

    onStart = (tableParams,filters) => {
        tableParams = tableParams || {};
        let _params = { ...tableParams };
        if(filters && filters.status){
            _params.status = filters.status;
        }
        if(this.filterParams){
            _params = {..._params,...this.filterParams};
        }

        return getBundles(_params).then(e => {
            this.setState({ list: e.data, total: e.data.length });
        });
    }
    componentDidMount() {
        //获取apikey列表
        getAppkeys().then(res=>{
            this.setState({hasAppKey:res.data.length!==0,loading:false});
        }).catch(()=>{
            this.setState({hasAppKey:false,loading:false});
        });
        this.table.change(1);
    }

    onNewBundle = ()=>{
        this.props.history.push('/pages/app/bundle/new');
    }

    render() {
        let disButton = true,tip = <br />;
        const has_permission = this.has_permission();
        if(!this.state.loading){
            if(has_permission && this.state.hasAppKey ){
                tip ='Bind the app\'s Bundle ID to the SDK for authorization recognition.';
                disButton = false;
            }else{
                tip ='Bind the app\'s Bundle ID to the SDK for authorization recognition.You need to contact us to apply for AppKey first.';
            }
        }

        return (
            <div className={style.bundle} id = 'bundle'>
                <div className={style.tips}>{tip}</div>
                <Button type="primary" disabled={disButton} onClick={this.onNewBundle}>New Bundle</Button>
                <BaseContent>
                    <Table
                        columns={this.columns}
                        dataSource={this.state.list}
                        onSubmit={this.onStart}
                        total={this.state.total}
                        ref={ref => this.table = ref}
                    />
                </BaseContent>
            </div>
        );
    }
}

function select(state) {
    return {
        account: state.account.info
    };
}
export default connect(select)(withRouter(BundleList));




// WEBPACK FOOTER //
// ./src/pages/BundleList/index.js